import { AuthRoles } from '../../config';
import { LanguagesEnum } from '../../config/languages';

const CONFIGURATION = {};

export const Translations = {
  page_title: {
    [LanguagesEnum.Greek]: 'Λεπτομέρειες Καταχώρησης',
    [LanguagesEnum.English]: 'Registration Details',
  },
  subtitle1: {
    [LanguagesEnum.Greek]: 'Review Registration Form',
    [LanguagesEnum.English]: 'Review Registration Form',
  },
  subtitle2: {
    [LanguagesEnum.Greek]:
      'You can review the existing Registration Details below. Using the form below and the available action buttons on the right section of the Header Title Bar, you can complete any missing required details, you can make any necessary Changes or Updates, you can request to be Excluded, and you can Submit the Registration Form accordingly for evaluation by the Tax Administration.',
    [LanguagesEnum.English]:
      'You can review the existing Registration Details below. Using the form below and the available action buttons on the right section of the Header Title Bar, you can complete any missing required details, you can make any necessary Changes or Updates, you can request to be Excluded, and you can Submit the Registration Form accordingly for evaluation by the Tax Administration.',
  },
  action_approve_reject: {
    [LanguagesEnum.Greek]: 'ΑΠΟΔΟΧΗ/ΑΠΟΡΡΙΨΗ',
    [LanguagesEnum.English]: 'APPROVE/REJECT',
  },
  action_temporary_save: {
    [LanguagesEnum.Greek]: 'ΠΡΟΣΩΡΙΝΗ ΑΠΟΘΗΚΕΥΣΗ',
    [LanguagesEnum.English]: 'SAVE TEMPORARY',
  },
  action_final_submit: {
    [LanguagesEnum.Greek]: 'ΥΠΟΒΟΛΗ',
    [LanguagesEnum.English]: 'FINAL SUBMIT',
  },
  identificationInOtherEuCountries_add_header_button: {
    [LanguagesEnum.English]: 'Add Identification in Other EU Countries',
    [LanguagesEnum.Greek]: 'Add Identification in Other EU Countries',
  },
  previousUseOfSpecialScheme_add_header_button: {
    [LanguagesEnum.English]: 'Add Previous Use of Special Schemes',
    [LanguagesEnum.Greek]: 'Προσθήκη Previous Use of Special Schemes',
  },
  fixedEstablishments_add_header_button: {
    [LanguagesEnum.English]: 'Add Fixed Establishment',
    [LanguagesEnum.Greek]: 'Add Fixed Establishment',
  },
  dialog_confirm_title: {
    [LanguagesEnum.English]: 'Registration Final Submit',
    [LanguagesEnum.Greek]: 'Registration Final Submit',
  },
  dialog_confirm_body: {
    [LanguagesEnum.English]: 'Are you sure you want to submit registration?',
    [LanguagesEnum.Greek]: 'Are you sure you want to submit registration?',
  },
  go_back: {
    [LanguagesEnum.English]: 'Go back without saving',
    [LanguagesEnum.Greek]: 'Go back without saving',
  },
};

export const allowedActions = {
  temporary: {
    state_status: ['0N', '0U', '0E'],
    roles: AuthRoles.Registered,
  },
  final: {
    state_status: ['0N', '0U', '0E'],
    roles: AuthRoles.Registered,
  },
  approve_reject: {
    state_status: ['1N', '1U', '4E'],
    roles: [AuthRoles.Admin],
  },
};

export interface FormFields {
  // IDENTIFICATION DETAILS
  identificationDetails_registrationId?: string | null;
  identificationDetails_username?: string | null;
  identificationDetails_intermediary?: string | null;
  identificationDetails_companyName?: string | null;
  identificationDetails_vatNumber?: string | null;
  identificationDetails_nationalTaxRefNumber?: string | null;
  identificationDetails_vatGroup?: boolean | null;
  identificationDetails_placeOfBusiness?: string | null;
  identificationDetails_issuingCountry?: string | null;
  identificationDetails_trading_name?: Array<string> | null;
  // CONTACT DETAILS
  contactDetails_firstName?: string | null;
  contactDetails_surname?: string | null;
  contactDetails_address?: string | null;
  contactDetails_number?: string | null;
  contactDetails_postalcode?: string | null;
  contactDetails_city?: string | null;
  contactDetails_country?: string | null;
  contactDetails_telephone?: string | null;
  contactDetails_email?: string | null;
  contactDetails_websites?: Array<string> | null;
  // PAYMENT DETAILS
  paymentInfo_iban?: string | null;
  paymentInfo_oban?: string | null;
  paymentInfo_iban_oban_selection?: string | null;
  paymentInfo_accountHolder?: string | null;
  paymentInfo_bic?: string | null;
  // FIRST SUPPLY DETAILS
  firstSupplyDetails_dateOfFirstSupply?: string | null;
  // CHANGE IDENTIFICATION
  changeIdentification_country: string | null;
  changeIdentification_vatNum: string | null;
  // EXCLUSION_DETAILS
  exclusionDetails_reason: string | null;
  exclusionDetails_cessationDate: Date | null;
  exclusionDetails_country: number | null;
  exclusionDetails_vatNum: string | null;
  exclusionDetails_comments: string | null;
  // DECLARATIONS
  declarations_electronicInterface: boolean;
  declarations_notEstablished: boolean;
  declarations_country_of_business_id: number | null;
}

export const initialDefaultValues = {
  // IDENTIFICATION DETAILS
  identificationDetails_registrationId: null,
  identificationDetails_username: null,
  identificationDetails_intermediary: null,
  identificationDetails_companyName: null,
  identificationDetails_vatNumber: null,
  identificationDetails_nationalTaxRefNumber: null,
  identificationDetails_vatGroup: false,
  identificationDetails_placeOfBusiness: null,
  identificationDetails_issuingCountry: null,
  identificationDetails_trading_name: null,
  // CONTACT DETAILS
  contactDetails_firstName: null,
  contactDetails_surname: null,
  contactDetails_address: null,
  contactDetails_number: null,
  contactDetails_postalcode: null,
  contactDetails_city: null,
  contactDetails_country: null,
  contactDetails_telephone: null,
  contactDetails_email: null,
  contactDetails_websites: null,
  // PAYMENT DETAILS
  paymentInfo_iban: null,
  paymentInfo_oban: null,
  paymentInfo_iban_oban_selection: null,
  paymentInfo_accountHolder: null,
  paymentInfo_bic: null,
  // FIRST SUPPLY DETAILS
  firstSupplyDetails_dateOfFirstSupply: null,
  // CHANGE IDENTIFICATION
  changeIdentification_country: null,
  changeIdentification_vatNum: null,
  // EXCLUSION DETAILS
  exclusionDetails_reason: null,
  exclusionDetails_cessationDate: null,
  exclusionDetails_country: null,
  exclusionDetails_vatNum: null,
  exclusionDetails_comments: null,
  // DECLARATIONS
  declarations_electronicInterface: false,
  declarations_notEstablished: false,
  declarations_country_of_business_id: null,
};

export default CONFIGURATION;
